import { styled } from "@mui/material";

export const AdminBg = styled("div")(() => ({
  "& .MuiToolbar-root ": {
    display: "flex",
    justifyContent: "space-between",
  },
}));
export const TableMui = styled("div")(() => ({
  padding: "15px",
  borderRadius: "8px",
  "& .MuiTypography-h5": {
    borderBottom: "1px solid",
    padding: "10px",
  },
}));
export const BorderBox = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "25px",

  "& .Boxes": {
    width: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px",
    borderRadius: "8px",
    "& svg": {
      fontSize: "2.5em",
    },
  },
}));
